import AnimatedIcon from '../../reels/AnimatedIcon';
import WildTextAnim from '../../reels/WildTextAnim';
import { Graphics } from 'pixi.js';
import { GameConfigs } from './GameConfigs';
import { isDesktop } from 'react-device-detect';

let mult = isDesktop ? 1 : 0.5;

export const ReelConfigMobile = {
	width: 5,
	height: 3,
	iconWidth: 232 / 2,
	iconHeight: 229 / 2,
	iconRealWidth: 216 / 2,
	iconRealHeight: 216 / 2,
	iconGap: 7 / 2,
	baitTime: 1000,
	scatterCodes: [10],
	divider: 'reel_divider',
	border: 'reel_border',
	reelsMask: false,
	animations: {
		eye_left: {
			pattern: 'pumpeyel$.png',
			start: 0,
			end: 24,
			speed: 0.5,
			loop: true
		},
		eye_right: {
			pattern: 'pumpkineyer$.png',
			start: 0,
			end: 24,
			speed: 0.5,
			loop: true
		}
	},
	icons: [
		{
			id: 0,
			IconClass: AnimatedIcon,
			icon: 'ten00.png',
			iconBlurred: 'minor_5_blurred',
			type: 'minor',
			animation: {
				fg: {
					pattern: 'ten$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.72,
						y: 0.72
					},
					offsetX: 0,
					offsetY: 0
				}
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'ten'
		},
		{
			id: 1,
			IconClass: AnimatedIcon,
			icon: 'j00.png',
			iconBlurred: 'minor_4_blurred',
			type: 'minor',
			animation: {
				fg: {
					pattern: 'j$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.72,
						y: 0.72
					},
					offsetX: 0,
					offsetY: 0
				}
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'jack'
		},
		{
			id: 2,
			IconClass: AnimatedIcon,
			icon: 'q00.png',
			iconBlurred: 'minor_3_blurred',
			type: 'minor',
			animation: {
				fg: {
					pattern: 'q$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.72,
						y: 0.72
					},
					offsetX: 0,
					offsetY: 0
				}
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'queen'
		},
		{
			id: 3,
			IconClass: AnimatedIcon,
			icon: 'k00.png',
			//   iconBg: "minor_2_bg",
			iconBlurred: 'minor_2_blurred',
			type: 'minor',
			animation: {
				fg: {
					pattern: 'k$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.72,
						y: 0.72
					},
					offsetX: 0,
					offsetY: 0
				}
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'king'
		},
		{
			id: 4,
			IconClass: AnimatedIcon,
			icon: 'a00.png',
			//   iconBg: "minor_1_bg",
			iconBlurred: 'minor_1_blurred',
			type: 'minor',
			animation: {
				fg: {
					pattern: 'a$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.72,
						y: 0.72
					},
					offsetX: 0,
					offsetY: 0
				}
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'ace'
		},
		{
			id: 5,
			IconClass: AnimatedIcon,
			icon: 'BG_Candy00.png',
			iconBg: 'major_5_bg',
			iconBlurred: 'major_5_blurred',
			iconBorder: 'major_5_frame',
			type: 'major',
			animation: {
				fg: {
					pattern: 'BG_Candy$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
				// frame: {
				//   pattern: "charframe$.png",
				//   start: 0,
				//   end: 71,
				//   speed: 0.5,
				//   loop: true,
				//   scale: {
				//     x: 0.96,
				//     y: 0.96,
				//   },
				// },
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'samurai'
		},
		{
			id: 6,
			IconClass: AnimatedIcon,
			icon: 'Dragon_BG00.png',
			iconBg: 'major_4_bg',
			iconBlurred: 'major_4_blurred',
			iconBorder: 'major_4_frame',
			type: 'major',
			animation: {
				fg: {
					pattern: 'Dragon_BG$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
				// frame: {
				//   pattern: "charframe$.png",
				//   start: 0,
				//   end: 71,
				//   speed: 0.5,
				//   loop: true,
				//   scale: {
				//     x: 0.96,
				//     y: 0.96,
				//   },
				// },
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'geisha'
		},
		{
			id: 7,
			IconClass: AnimatedIcon,
			icon: 'BG_Vampire00.png',
			iconBg: 'major_3_bg',
			iconBlurred: 'major_3_blurred',
			type: 'major',
			iconBorder: 'major_3_frame',
			animation: {
				fg: {
					pattern: 'BG_Vampire$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false
					// scale: {
					//   x: 0.96,
					//   y: 0.96,
					// },
				}
				// frame: {
				//   pattern: "charframe$.png",
				//   start: 0,
				//   end: 71,
				//   speed: 0.5,
				//   loop: true,
				//   scale: {
				//     x: 0.96,
				//     y: 0.96,
				//   },
				// },
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'emperess'
		},
		{
			id: 8,
			IconClass: AnimatedIcon,
			icon: 'BG_Death00.png',
			iconBlurred: 'major_2_blurred',
			iconBg: 'major_2_bg',
			type: 'major',
			iconBorder: 'major_2_frame',
			animation: {
				fg: {
					pattern: 'BG_Death$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
				// frame: {
				//   pattern: "charframe$.png",
				//   start: 0,
				//   end: 71,
				//   speed: 0.5,
				//   loop: true,
				//   scale: {
				//     x: 0.96,
				//     y: 0.96,
				//   },
				// },
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'minister'
		},
		{
			id: 9,
			IconClass: AnimatedIcon,
			icon: 'Witch_BG00.png',
			iconBg: 'major_1_bg',
			iconBlurred: 'major_1_blurred',
			type: 'major',
			iconBorder: 'major_1_frame',
			animation: {
				fg: {
					pattern: 'Witch_BG$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					precision: 2,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
				// frame: {
				//   pattern: "charframe$.png",
				//   start: 0,
				//   end: 71,
				//   speed: 0.5,
				//   loop: true,
				//   scale: {
				//     x: 0.96,
				//     y: 0.96,
				//   },
				// },
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'general'
		},
		{
			id: 10,
			IconClass: AnimatedIcon,
			Fg2Class: WildTextAnim,
			icon: 'book00.png',
			//   iconBg: "scatter_bg",
			type: 'scatter',
			iconBlurred: 'scatter_blurred',
			isScatter: true,
			animation: {
				fg: {
					pattern: 'book$.png',
					start: 0,
					end: 37,
					speed: 0.5,
					loop: false,
					precision: 2,
					scale: {
						x: 0.96,
						y: 0.96
					},
					sound: 'scatter_impact_sfx'
					// offsetX: 0,
					// offsetY: -15
				},
				fg2Index: 0,
				fg2Data: [
					{
						pattern: 'Comp4$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						// scale: {
						//   x: 0.5,
						//   y: 0.5,
						// },
						offsetX: 6,
						offsetY: 150 / 2
					}
				]
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'scatter'
		},
		{
			id: 11,
			IconClass: AnimatedIcon,
			Fg2Class: WildTextAnim,
			icon: 'Pump00',
			iconBgRotate: 'wild_bg',
			iconBg: 'wild_bg',
			iconBgBonus: 'Pump00.png',
			type: 'wild',
			iconBlurred: 'wild_blurred',
			isWild: true,
			isSticked: false,
			animation: {
				frame: {
					pattern: 'wildframe$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: true,
					offsetX: -10,
					offsetY: -13 / 2,
					scale: {
						x: 1 * mult,
						y: 1 * mult
					}
				},
				bonusBg: {
					pattern: 'wildframe$.png',
					start: 0,
					end: 23,
					speed: 0.5,
					loop: true,
					offsetX: -10,
					offsetY: -13 / 2,
					scale: {
						x: 1 * mult,
						y: 1 * mult
					}
				},
				fg: {
					pattern: 'Pump$.png',
					start: 0,
					end: 47,
					speed: 0.5,
					loop: false,
					scale: {
						x: 1,
						y: 1
					},
					offsetX: 4 / 2,
					offsetY: 4 / 2,
					sound: 'wild_shooting_sfx'
				},

				fg2Index: 0,
				fg2Data: [
					{
						pattern: 'wild$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						scale: {
							x: 1,
							y: 1
						},
						offsetX: 0,
						offsetY: 150 / 2
					},
					{
						pattern: 'wild2$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						scale: {
							x: 1,
							y: 1
						},
						offsetX: 0,
						offsetY: 150 / 2
					},
					{
						pattern: 'wild3$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						scale: {
							x: 1,
							y: 1
						},
						offsetX: 0,
						offsetY: 150 / 2
					},
					{
						pattern: 'wild4$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						scale: {
							x: 1,
							y: 1
						},
						offsetX: 0,
						offsetY: 150 / 2
					},
					{
						pattern: 'wild5$.png',
						start: 0,
						end: 23,
						speed: 0.5,
						loop: true,
						scale: {
							x: 1,
							y: 1
						},
						offsetX: 0,
						offsetY: 150 / 2
					}
				]
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'wild'
		},
		{
			id: 12,
			IconClass: AnimatedIcon,
			icon: '02_CrystalUnstable00',
			// iconBg: "major_2_bg",
			iconBlurred: 'special_blurred',
			animation: {
				fg: {
					pattern: '02_CrystalUnstable$.png',
					start: 0,
					end: 71,
					speed: 0.5,
					loop: false,
					scale: {
						x: 0.96,
						y: 0.96
					}
				}
			},
			width: 216 / 2,
			height: 216 / 2,
			name: 'special'
		}
	],
	linesConfig: {
		lines: [
			[1, 1, 1, 1, 1],
			[0, 0, 0, 0, 0],
			[2, 2, 2, 2, 2],
			[0, 1, 2, 1, 0],
			[2, 1, 0, 1, 2],
			[0, 0, 1, 0, 0],
			[2, 2, 1, 2, 2],
			[1, 2, 2, 2, 1],
			[1, 0, 0, 0, 1]
		],
		animationTime: GameConfigs.settings.game_animation ? 2300 : 1000
	},
	reelMask: (u, d, w, h) => {
		var maskGraphics = new Graphics();
		maskGraphics.clear();
		maskGraphics.beginFill(0xffffff);
		maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
		maskGraphics.endFill();
		return maskGraphics;
	},
	reelsMask2: (u, d, w, h) => {
		var maskGraphics = new Graphics();
		maskGraphics.clear();
		maskGraphics.beginFill(0xff0000);
		maskGraphics.drawRoundedRect(-u, 0, w + d, h, 0);
		maskGraphics.endFill();
		return maskGraphics;
	}
};
